import { Button } from '@shared/components/shadcn';
import Link from 'next/link';
import type { StaticActionLink } from '../types';
import { toStaticLinkTargetProps } from '../utils/staticLinkTarget';

type StaticActionProps = {
  action: StaticActionLink;
  'data-testid'?: string;
};

/**
 * Call-to-action button sourced from static page JSON.
 *
 * Use for one-off actions such as downloading a PDF. Renders as a button-styled
 * link: root-relative and hash hrefs stay in the current tab, anything else opens
 * in a new tab. Keep labels and hrefs in the page data rather than hardcoding
 * them in the page component. Shares the small secondary styling of
 * {@link StaticBackToTopLink}, without the arrow icon.
 *
 * @param action - Label and href from a `{ type: 'action' }` content block or a section `action`
 */
function StaticAction({ action, 'data-testid': dataTestId = 'static-action' }: StaticActionProps) {
  return (
    <Button asChild variant="secondary" size="s" className="self-start" data-testid={dataTestId}>
      <Link href={action.href} {...toStaticLinkTargetProps(action.href)}>
        {action.label}
      </Link>
    </Button>
  );
}

export { StaticAction, type StaticActionProps };
